import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class EmailSenderService {

  constructor() { }


  public email = () => {
    let emailAddress = "info@didovendeghaz.hu";
    let subject = "Érdeklődés";
    let body = "Tisztelt DIDO Vendégház!\n\nÉrdeklődni szeretnék a szabad szálláslehetőségekről.\n\nKöszönettel,\n[Név]";
    let email = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    const mailtoLink = document.createElement("a");
    mailtoLink.href = email;
    mailtoLink.click();
    mailtoLink.remove();
  }
  sendEmail(to: string, subject: string, body: string): void {

  }
}